var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Card",
    {
      staticClass: "discounts am-margin-bottom-sm",
      attrs: { headerStyle: { background: "#d4d5d5" }, "dis-hover": "" }
    },
    [
      _c(
        "div",
        { staticClass: "am-cf", attrs: { slot: "title" }, slot: "title" },
        [_c("h2", [_vm._v("\n      优惠活动\n    ")])]
      ),
      _c(
        "div",
        {
          staticStyle: { transform: "translateY(-25%)" },
          attrs: { slot: "extra" },
          slot: "extra"
        },
        [
          _vm.store.isSupportDiscount
            ? _c(
                "Button",
                {
                  staticClass: "am-margin-left-sm",
                  attrs: { disabled: !_vm.isAddCart },
                  nativeOn: {
                    click: function($event) {
                      return _vm.discountsModal.apply(null, arguments)
                    }
                  }
                },
                [_vm._v("手动打折\n    ")]
              )
            : _vm._e()
        ],
        1
      ),
      _c("p", { staticClass: "discounts-action-title" }, [
        _vm._v(
          "原订单总优惠金额：" +
            _vm._s(Math.abs(_vm.originOrderDiscountPrice)) +
            " "
        )
      ]),
      _c(
        "ul",
        { staticClass: "desc" },
        [
          _c("li", [
            _vm._v("原订单优惠活动 \n      "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.orderPreferentials.length,
                    expression: "!orderPreferentials.length"
                  }
                ]
              },
              [_vm._v("-")]
            )
          ]),
          _vm._l(_vm.orderPreferentials, function(item, index) {
            return _c("li", { key: index }, [
              _vm._v(
                "\n     " +
                  _vm._s(index + 1) +
                  "、" +
                  _vm._s(_vm._f("preferentialType")(item.type)) +
                  "：" +
                  _vm._s(item.content) +
                  "\n    "
              )
            ])
          })
        ],
        2
      ),
      _vm.manualPreferentials.length > 0
        ? _c("div", { staticClass: "discounts-action-list" }, [
            _c("div", { staticClass: "discounts-action-title" }, [
              _vm._v("\n      手动打折不需要发票\n    ")
            ]),
            _c(
              "div",
              { staticClass: "am-padding-left-sm" },
              _vm._l(_vm.manualPreferentials, function(item) {
                return _c(
                  "p",
                  { key: item._key, staticClass: "discounts-action-item" },
                  [_vm._v("\n        " + _vm._s(item.content) + "\n      ")]
                )
              }),
              0
            )
          ])
        : _vm._e(),
      _c("div", { staticClass: "discounts-price" }, [
        _c("span", { staticClass: "am-padding-right-sm" }, [
          _vm._v(
            "总优惠金额：" + _vm._s(_vm.currency) + _vm._s(_vm.subtractAmount)
          )
        ]),
        _c("span", { staticClass: "discount-pay-price" }, [
          _vm._v(
            "顾客需付: " +
              _vm._s(_vm.currency) +
              _vm._s(_vm._f("formatPrice")(_vm.total, true)) +
              "(已含优惠)"
          )
        ])
      ]),
      _c("cc-loading-box", {
        staticClass: "loading-box",
        attrs: { isLoading: _vm.isLoading }
      }),
      _c(
        "Modal",
        {
          attrs: { width: "850px" },
          model: {
            value: _vm.service.visible,
            callback: function($$v) {
              _vm.$set(_vm.service, "visible", $$v)
            },
            expression: "service.visible"
          }
        },
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _vm._v("手动打折")
          ]),
          _c(
            "div",
            { staticClass: "service am-g-collapse" },
            [
              _c(
                "CheckboxGroup",
                {
                  on: {
                    "on-change": function($event) {
                      return _vm.handleCheckBoxGroup(_vm.service.type)
                    }
                  },
                  model: {
                    value: _vm.service.type,
                    callback: function($$v) {
                      _vm.$set(_vm.service, "type", $$v)
                    },
                    expression: "service.type"
                  }
                },
                [
                  _c("div", { staticClass: "service-pane" }, [
                    _c("div", { staticClass: "am-g" }, [
                      _c(
                        "div",
                        { staticClass: "am-u-sm-3" },
                        [
                          _c("Checkbox", { attrs: { label: 0 } }, [
                            _vm._v("全单打折")
                          ])
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "u-sm-9" },
                        [
                          _c(
                            "RadioGroup",
                            {
                              model: {
                                value: _vm.service.allProduct.checkValue,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.service.allProduct,
                                    "checkValue",
                                    $$v
                                  )
                                },
                                expression: "service.allProduct.checkValue"
                              }
                            },
                            [
                              _c("Radio", {
                                attrs: {
                                  label: 2,
                                  disabled: _vm.service.allProduct.disabled
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var currentValue = ref.currentValue
                                      return _c(
                                        "span",
                                        {},
                                        [
                                          _vm._v(
                                            "\n                     折扣设置"
                                          ),
                                          _c("InputQuantity", {
                                            staticClass: "service-input",
                                            attrs: {
                                              prepend: "",
                                              append: "",
                                              size: "small",
                                              max: 99,
                                              disabled:
                                                _vm.service.allProduct
                                                  .disabled || !currentValue
                                            },
                                            model: {
                                              value:
                                                _vm.service.allProduct.fold,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.service.allProduct,
                                                  "fold",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "service.allProduct.fold"
                                            }
                                          }),
                                          _vm._v("%\n                  ")
                                        ],
                                        1
                                      )
                                    }
                                  }
                                ])
                              }),
                              _c("Radio", {
                                staticClass: "am-padding-left-sm",
                                attrs: {
                                  label: 4,
                                  disabled: _vm.service.allProduct.disabled
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var currentValue = ref.currentValue
                                      return _c(
                                        "span",
                                        {},
                                        [
                                          _c("span", [
                                            _vm._v(
                                              "减免金额" + _vm._s(_vm.currency)
                                            )
                                          ]),
                                          _c("Input", {
                                            staticClass: "service-input",
                                            attrs: {
                                              size: "small",
                                              number: "",
                                              disabled:
                                                _vm.service.allProduct
                                                  .disabled || !currentValue
                                            },
                                            on: {
                                              "on-blur": function($event) {
                                                return _vm.handleValidateService(
                                                  _vm.service.allProduct
                                                )
                                              }
                                            },
                                            model: {
                                              value: _vm.service.allProduct.sum,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.service.allProduct,
                                                  "sum",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "service.allProduct.sum"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    }
                                  }
                                ])
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  ]),
                  _c(
                    "div",
                    { staticClass: "service-pane" },
                    [
                      _c("Checkbox", { attrs: { label: 1 } }, [
                        _vm._v("餐品打折")
                      ])
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.service.show,
                          expression: "service.show"
                        }
                      ],
                      staticClass:
                        "service-pane-content am-text-center am-scroll"
                    },
                    [
                      _vm.service.products.length > 0
                        ? [
                            _c(
                              "div",
                              { staticClass: "am-g am-margin-bottom-sm" },
                              [
                                _c("div", { staticClass: "am-u-sm-3" }, [
                                  _vm._v("餐品名称")
                                ]),
                                _c("div", { staticClass: "am-u-sm-1" }, [
                                  _vm._v("小计")
                                ]),
                                _c("div", { staticClass: "am-u-sm-1" }, [
                                  _vm._v("数量")
                                ]),
                                _c("div", { staticClass: "am-u-sm-2" }, [
                                  _vm._v("打折份数")
                                ]),
                                _c("div", { staticClass: "am-u-sm-5" }, [
                                  _vm._v("折扣")
                                ])
                              ]
                            ),
                            _vm._l(_vm.service.products, function(item, index) {
                              return _c(
                                "div",
                                { key: index, staticClass: "am-g" },
                                [
                                  !item.readonly
                                    ? [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "am-u-sm-12 am-margin-bottom-sm"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "am-u-sm-3 am-text-left service-product-name"
                                              },
                                              [
                                                item.type === 2 ||
                                                item.isRequirement
                                                  ? [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "service-triangle-contain",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              item._discount.show = !item
                                                                ._discount.show
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("span", {
                                                            staticClass:
                                                              "service-triangle",
                                                            class: {
                                                              expand:
                                                                item._discount
                                                                  .show
                                                            }
                                                          })
                                                        ]
                                                      )
                                                    ]
                                                  : _vm._e(),
                                                _c("span", [
                                                  _vm._v(_vm._s(item.name))
                                                ])
                                              ],
                                              2
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "am-u-sm-1" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("formatPrice")(
                                                      item.totalProductPrice,
                                                      true
                                                    )
                                                  )
                                                )
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "am-u-sm-1" },
                                              [_vm._v(_vm._s(item.num))]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "am-u-sm-2" },
                                              [
                                                _c("InputQuantity", {
                                                  staticClass: "service-input",
                                                  attrs: {
                                                    prepend: "",
                                                    append: "",
                                                    size: "small",
                                                    max: item.num,
                                                    min: 0
                                                  },
                                                  model: {
                                                    value: item._discount.num,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        item._discount,
                                                        "num",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "item._discount.num"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "am-u-sm-5" },
                                              [
                                                _c(
                                                  "RadioGroup",
                                                  {
                                                    model: {
                                                      value:
                                                        item._discount
                                                          .checkValue,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          item._discount,
                                                          "checkValue",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "item._discount.checkValue"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      { staticClass: "am-cf" },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "am-fl"
                                                          },
                                                          [
                                                            _c("Radio", {
                                                              attrs: {
                                                                label: 1,
                                                                disabled:
                                                                  item._discount
                                                                    .num <= 0
                                                              },
                                                              scopedSlots: _vm._u(
                                                                [
                                                                  {
                                                                    key:
                                                                      "default",
                                                                    fn: function(
                                                                      ref
                                                                    ) {
                                                                      var currentValue =
                                                                        ref.currentValue
                                                                      return _c(
                                                                        "span",
                                                                        {},
                                                                        [
                                                                          _vm._v(
                                                                            "\n                            折扣设置"
                                                                          ),
                                                                          _c(
                                                                            "InputQuantity",
                                                                            {
                                                                              staticClass:
                                                                                "service-input",
                                                                              attrs: {
                                                                                max: 99,
                                                                                min:
                                                                                  "0",
                                                                                prepend:
                                                                                  "",
                                                                                append:
                                                                                  "",
                                                                                size:
                                                                                  "small",
                                                                                disabled:
                                                                                  item
                                                                                    ._discount
                                                                                    .num <=
                                                                                    0 ||
                                                                                  !currentValue
                                                                              },
                                                                              model: {
                                                                                value:
                                                                                  item
                                                                                    ._discount
                                                                                    .fold,
                                                                                callback: function(
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.$set(
                                                                                    item._discount,
                                                                                    "fold",
                                                                                    $$v
                                                                                  )
                                                                                },
                                                                                expression:
                                                                                  "item._discount.fold"
                                                                              }
                                                                            }
                                                                          ),
                                                                          _vm._v(
                                                                            "%\n                          "
                                                                          )
                                                                        ],
                                                                        1
                                                                      )
                                                                    }
                                                                  }
                                                                ],
                                                                null,
                                                                true
                                                              )
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "am-fr"
                                                          },
                                                          [
                                                            _c("Radio", {
                                                              attrs: {
                                                                label: 3,
                                                                disabled:
                                                                  item._discount
                                                                    .num <= 0
                                                              },
                                                              scopedSlots: _vm._u(
                                                                [
                                                                  {
                                                                    key:
                                                                      "default",
                                                                    fn: function(
                                                                      ref
                                                                    ) {
                                                                      var currentValue =
                                                                        ref.currentValue
                                                                      return _c(
                                                                        "span",
                                                                        {},
                                                                        [
                                                                          _c(
                                                                            "span",
                                                                            [
                                                                              _vm._v(
                                                                                "减免金额" +
                                                                                  _vm._s(
                                                                                    _vm.currency
                                                                                  )
                                                                              )
                                                                            ]
                                                                          ),
                                                                          _c(
                                                                            "Input",
                                                                            {
                                                                              staticClass:
                                                                                "service-input",
                                                                              attrs: {
                                                                                size:
                                                                                  "small",
                                                                                disabled:
                                                                                  item
                                                                                    ._discount
                                                                                    .num <=
                                                                                    0 ||
                                                                                  !currentValue,
                                                                                number:
                                                                                  ""
                                                                              },
                                                                              on: {
                                                                                "on-blur": function(
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.handleValidateService(
                                                                                    item._discount
                                                                                  )
                                                                                }
                                                                              },
                                                                              model: {
                                                                                value:
                                                                                  item
                                                                                    ._discount
                                                                                    .sum,
                                                                                callback: function(
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.$set(
                                                                                    item._discount,
                                                                                    "sum",
                                                                                    $$v
                                                                                  )
                                                                                },
                                                                                expression:
                                                                                  "item._discount.sum"
                                                                              }
                                                                            }
                                                                          )
                                                                        ],
                                                                        1
                                                                      )
                                                                    }
                                                                  }
                                                                ],
                                                                null,
                                                                true
                                                              )
                                                            })
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: item._discount.show,
                                                expression:
                                                  "item._discount.show "
                                              }
                                            ]
                                          },
                                          [
                                            item.isRequirement
                                              ? [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "am-u-sm-12"
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "am-fl am-padding-left-sm"
                                                        },
                                                        [_vm._v("特殊要求：")]
                                                      ),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "am-fl"
                                                        },
                                                        _vm._l(
                                                          item.desc,
                                                          function(
                                                            text,
                                                            index
                                                          ) {
                                                            return _c(
                                                              "span",
                                                              {
                                                                key: index,
                                                                staticClass:
                                                                  "am-padding-left-sm"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                      " +
                                                                    _vm._s(
                                                                      text
                                                                    ) +
                                                                    "\n                    "
                                                                )
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      )
                                                    ]
                                                  )
                                                ]
                                              : item.type === 2
                                              ? _vm._l(item.products, function(
                                                  product,
                                                  index
                                                ) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: index,
                                                      staticClass:
                                                        "am-u-sm-12 am-margin-bottom-sm"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "am-u-sm-4 am-text-left"
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "am-padding-left-sm"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  product.name
                                                                ) + " "
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "am-u-sm-1 am-text-center am-u-end"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(product.num)
                                                          )
                                                        ]
                                                      ),
                                                      product.desc
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "am-u-sm-12 am-padding-top-sm"
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "am-fl am-padding-left-sm"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "特殊要求："
                                                                  )
                                                                ]
                                                              ),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "am-fl"
                                                                },
                                                                _vm._l(
                                                                  product.desc,
                                                                  function(
                                                                    text,
                                                                    index
                                                                  ) {
                                                                    return _c(
                                                                      "span",
                                                                      {
                                                                        key: index,
                                                                        staticClass:
                                                                          "am-padding-left-sm"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            text
                                                                          )
                                                                        )
                                                                      ]
                                                                    )
                                                                  }
                                                                ),
                                                                0
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  )
                                                })
                                              : _vm._e()
                                          ],
                                          2
                                        )
                                      ]
                                    : _vm._e()
                                ],
                                2
                              )
                            })
                          ]
                        : [
                            _vm._v(
                              "\n            没有符合打折的餐品\n          "
                            )
                          ]
                    ],
                    2
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "am-text-right",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "Button",
                {
                  nativeOn: {
                    click: function($event) {
                      return _vm.saveDiscountsService.apply(null, arguments)
                    }
                  }
                },
                [_vm._v("保存")]
              ),
              _c(
                "Button",
                {
                  staticClass: "am-btn-cancel",
                  nativeOn: {
                    click: function($event) {
                      _vm.service.visible = false
                    }
                  }
                },
                [_vm._v("取消")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-de663bdc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-de663bdc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/pages/order/Discounts/DiscountsNew.vue
// module id = z7VF
// module chunks = 0